import { createStore } from "zustand/vanilla";
import { useStore } from "zustand";

import { useAppRuntime } from "../../providers/AppRuntimeProvider";
import type { AppRuntime } from "../../runtime/contracts";

export interface ExtensionsStoreState {
  selectedKey: string | undefined;
  searchQuery: string;
  actions: {
    setSelectedKey: (key: string | undefined) => void;
    setSearchQuery: (query: string) => void;
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function createExtensionsStore(_runtime: AppRuntime) {
  return createStore<ExtensionsStoreState>((set) => ({
    selectedKey: undefined,
    searchQuery: "",
    actions: {
      setSelectedKey: (key: string | undefined): void => {
        set({ selectedKey: key });
      },
      setSearchQuery: (query: string): void => {
        set({ searchQuery: query });
      },
    },
  }));
}

export type ExtensionsStore = ReturnType<typeof createExtensionsStore>;

export function useExtensionsStore(): ExtensionsStoreState;
export function useExtensionsStore<T>(
  selector: (state: ExtensionsStoreState) => T,
): T;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function useExtensionsStore<T>(
  selector?: (state: ExtensionsStoreState) => T,
) {
  const runtime = useAppRuntime();
  const store = runtime.stores.get<ExtensionsStore>("extensions");
  if (!store) throw new Error("Extensions store not initialized");
  return useStore(store, selector ?? ((s): T => s as unknown as T));
}
